import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: '',
    component: Home,
    redirect: "/index",
    children: [{
      path: '/index',
      name: '首页',
      component: () => import('@/views/index.vue'),
    }]
  },
  {
      path: '/stastic',
      name: '数据统计',
	  component: Home,
	  children: [
		  {
		    path: '/userStastic',
		    name: '用户数据',
		    component: () => import('@/views/stastic/userStastic.vue'),
		  },
		  {
		    path: '/pageStastic',
		    name: '页面数据',
		    component: () => import('@/views/stastic/pageStastic.vue'),
		  },
		  {
		    path: '/buttonStastic',
		    name: '按钮数据',
		    component: () => import('@/views/stastic/buttonStastic.vue'),
		  },
		  {
		    path: '/renderStastic',
		    name: '炫图统计',
		    component: () => import('@/views/stastic/renderStastic.vue'),
		  },
	  ]
  },
  {
    path: '/',
    name: '',
    component: Home,
    children: [
      {
        path: '/orderBoard',
        name: '订单看板',
        component: () => import('@/views/orderBoard.vue'),
      },
      {
        path: '/SalesSettings',
        name: '销售设置',
        component: () => import('@/views/SalesSettings.vue'),
      },
      {
        path: '/PaymentLog',
        name: '付款记录',
        component: () => import('@/views/PaymentLog.vue'),
      },
      {
        path: '/CashLog',
        name: '提现申请记录',
        component: () => import('@/views/CashLog.vue'),
      }
    ]
  },
  {
    path: '/',
    name: '',
    component: Home,
    children: [{
      path: '/promotionman',
      name: '推广管理',
      component: () => import('@/views/promote/promotionman.vue'),
    },
    {
      path: '/promotionadd',
      name: '创建推广',
      component: () => import('@/views/promote/promotionadd.vue'),
    }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/Login.vue'),
  },
  {
    path: '/',
    name: '系统管理',
    component: Home,
    children: [
      {
        path: '/report-manager', name: '报表管理',
        component: () => import('@/views/system-setting/report-manager.vue'),
      },
      {
        path: '/modules-manager', name: '功能模块管理',
        component: () => import('@/views/system-setting/modules-manager.vue'),
      },
      {
        path: '/create-account', name: '开账号',
        component: () => import('@/views/system-setting/create-account.vue'),
      },
      {
        path: '/del-account', name: '关账号',
        component: () => import('@/views/system-setting/del-account.vue'),
      },
      {
        path: '/update-account', name: '升级账号',
        component: () => import('@/views/system-setting/update-account.vue'),
      },
      {
        path: '/set-proxy', name: '设置代理商',
        component: () => import('@/views/system-setting/set-proxy.vue'),
      },
	  {
	    path: '/account-manage', name: '账号管理',
	    component: () => import('@/views/system-setting/account-manage.vue'),
	  },
	  {
	    path: '/user-manage/:id', name: '子用户管理',
	    component: () => import('@/views/system-setting/account-manage.vue'),
	  },
	  {
	    path: '/proxy-list', name: '代理商列表',
	    component: () => import('@/views/system-setting/proxy-list.vue'),
	  },
	  {
	    path: '/abnormal-users', name: '异常用户',
	    component: () => import('@/views/system-setting/abnormal-users.vue'),
	  },
	  {
	    path: '/proxy-list/:id', name: '代理商详情',
	    component: () => import('@/views/system-setting/proxy-detail.vue'),
		meta: {
			canBack: true
		}
	  }
    ]
  },
  {
    path: '/',
    name: '迁移公式',
	component: Home,
    children: [
		{
			path: '/migrateProduct',
			name: '迁移公式',
			component: () => import('@/views/migrateProduct.vue'),
		}
	]
  },
  {
    path: '/',
    name: '官网留言',
  	component: Home,
    children: [
  		{
  			path: '/customerMessage',
  			name: '官网留言',
  			component: () => import('@/views/customerMessage.vue'),
  		}
  	]
  },
  {
    path: '/',
    name: '门窗资讯',
  	component: Home,
    children: [
  		{
  			path: '/articleList',
  			name: '门窗资讯',
  			component: () => import('@/views/module/articleList.vue'),
  		},
		{
			path: '/articleDetail',
			name: '资讯添加',
			component: () => import('@/views/module/articleDetail.vue'),
		},
		{
			path: '/articleDetail/:id',
			name: '资讯编辑',
			component: () => import('@/views/module/articleDetail.vue'),
		},
		{
			path: '/commentList/:id',
			name: '评论列表',
			component: () => import('@/views/module/commentList.vue'),
		},
  	]
  },
  {
    path: '/',
    name: 'App版本更新',
  	component: Home,
    children: [
  		{
  			path: '/appVersionUpdate',
  			name: 'App版本更新',
  			component: () => import('@/views/appVersionUpdate.vue'),
  		}
  	]
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    //去登陆页就清除session中所有数据
    sessionStorage.clear();
  }
  let userinfo = sessionStorage.getItem('userinfo');
  //判断session中有没有用户信息 如果有就正常跳转，没有就去登陆页
  if (!userinfo && to.path != '/login') {
    next({
      path: '/login'
    })
  } else {
    next()
  }
})


export default router